import { FC } from 'react';
import GooglePlayLogo from './assets/logo-external/logo-google-play.svg';

const LogoGooglePlay: FC = () => {
  return <img src={GooglePlayLogo} alt="Google Play" style={{ maxWidth: '100%', maxHeight: '100%' }} />;
};

export default LogoGooglePlay;
